// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === "assets_js_badLinksDetect_js") return "./js/chunks/9f623137b0c8720e2c93.js";
	if (chunkId === "assets_js_modules_common_js") return "./js/chunks/2734b287ce6a979171aa.js";
	if (chunkId === "assets_js_modules_grid_js") return "./js/chunks/4f68fe9ace053fe7a688.js";
	if (chunkId === "assets_js_modules_header_js") return "./js/chunks/c25c506c72c02d16f08f.js";
	if (chunkId === "assets_js_modules_home_js") return "./js/chunks/a77f8b3749dafd05e3f8.js";
	if (chunkId === "assets_js_modules_popin_js") return "./js/chunks/df7fa83c444e96294452.js";
	if (chunkId === "assets_js_modules_popinJournal_js") return "./js/chunks/11892a07c38dcc6c42bf.js";
	if (chunkId === "assets_js_modules_reveal_js") return "./js/chunks/242e8d2b8f134deef502.js";
	if (chunkId === "vendors-node_modules_gsap_ScrollTrigger_js-node_modules_gsap_index_js") return "./js/chunks/af3ef071799a707b3657.js";
	if (chunkId === "assets_js_modules_upwards_js") return "./js/chunks/a784a6597506ddcc4e6a.js";
	if (chunkId === "assets_js_modules_video_js") return "./js/chunks/4e7cd817a938bc32aba1.js";
	if (chunkId === "assets_js_modules_youtube_js") return "./js/chunks/30752ad08209ea626c22.js";
	// return url for filenames based on template
	return undefined;
};